import React, { useState, useEffect } from "react";
import { useSurveySrv } from "./useSurveySrv";
import { useSurveyAdapterMemeberPortal } from "./useSurveyAdapterMemeberPortal";
import { clearLocalStore } from "helpers/localStoreSrv";
import { Survey } from "hlscomponents";
import { useUiState } from "helpers/useUiState";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ReactGA from "react-ga";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { getLanguageId, LANGUAGES } from "constants/supported_lang";
import { useMemberActivityListSrv } from "./useMemberActivityListSrv";
import { usePageTitle } from "helpers/usePageTitle";
import { useSessionDetailLog } from "helpers/useSessionDetailLog";
const SurveyMemberPortal = (props: any) => {
  const location = useLocation();
  const renderHtml = location.state && location.state.renderHtml;
  // const surveyLanguage = useSelector(
  //   (state) => state.portal.uiState.SurveyLanguage
  // );
  // console.log("surveyLanguage", surveyLanguage);
  let { rawSurveyData } = location.state;
  console.log("rawSurveyData", rawSurveyData.PreferredLanguage);
  //const { preferredLanguageForSurvey } = location.state || {};
  const [answered, setAnswered] = useState(false);
  const preferredLanguageForSurvey = localStorage.getItem(
    "preferredLanguageForSurvey"
  );
  console.log("Preferred Language:", preferredLanguageForSurvey);
  const { isAppLoading } = useUiState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [surveyData, setSurveyData] = useState({});
  const {
    memberPortalsubmitSurveyData,
    submitUploadDocument,
    updatePatientActivityDetailID,
    deleteDocument,
    getLanguageTranslations,
    partialSurveyDataRulebased,
    partialSurveyData,
    lastSeenPageNumberData,
  } = useSurveySrv();
  const { parseFromSource, parseToSource } =
    useSurveyAdapterMemeberPortal(rawSurveyData);
  const { httpGetMemberActivities, mergeSurveyJson } =
    useMemberActivityListSrv();
  const navigate = useNavigate();
  const { logSessionDetail } = useSessionDetailLog();
  const { t } = useTranslation();
  usePageTitle("SURVEY_PAGE.PAGE_TITLE", `Survey - ${process.env.REACT_APP_PRODUCT}`);
  const appUiState = useSelector((state: any) => state.portal.uiState);

  const [rueBasedActivities, setrueBasedActivities] = useState();
  const [finalResponse, setFinalResponse] = useState([]);
  // const [currentLanguage, setCurrentLanguage] = useState(
  //   preferredLanguageForSurvey
  // );
  const [cachedJSON, setCachedJSON] = useState<any[]>([]);
  const [surveyList, setSurveyList] = useState();
  const questionType = 120000008;
  const [PatientActivityDetailID, setPatientActivityDetailID] = useState("");
  const [patientActivityID, setPatientActivityID] = useState(null);
  const [lastseenPageNumberVal, setLastseenPageNumberVal] = useState(null);
  const languageCode = LANGUAGES.find(
    (lang) => lang.id === rawSurveyData.PreferredLanguage
  );
  const [surveyLanguage, setSurveyLanguage] = useState(
    languageCode?.code || "en"
  );
  const [finalAppLanguage, setFinalAppLanguage] = useState("en");
  const updateQuestionsByLang = (
    data: any,
    languageCode: any,
    langData: any,
    rawData: any
  ) => {
    const updatedJson =
      langData?.filter((item: any) => item.LanguageCode === languageCode) || [];
    const engDataJson =
      langData?.filter((item: any) => item.LanguageCode === 120000000) || [];
    const updatedSurveyData = data.PatientActivityDetails.map((detail: any) => {
      if (rawData) {
        const testData = rawData.surveyPages;
        const correspondingQuestion = testData!
          .flatMap((page: any) => page.surveyQuestions)
          .find(
            (question: any) => question.questionCode === detail.QuestionCode
          );

        if (correspondingQuestion && correspondingQuestion.ChoicesTextCode) {
          detail.ChoicesTextCode = correspondingQuestion.ChoicesTextCode;
          detail.QuestionTextCode = correspondingQuestion.QuestionTextCode;
          detail.SectionName = correspondingQuestion.SectionName;
          detail.SubSectionName = correspondingQuestion.SubSectionName;
          detail.NoneOfTheAboveText = correspondingQuestion.NoneOfTheAboveText;
          detail.NoneOfTheAboveTextCode =
            correspondingQuestion.NoneOfTheAboveTextCode;
          detail.IsNoneOfTheAboveEnabled =
            correspondingQuestion.IsNoneOfTheAboveEnabled;
        } else {
          detail.ChoicesTextCode = "Q7CH";
          detail.QuestionTextCode = "Q7";
        }
      }
      const englishChoicesMatch = engDataJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.ChoicesTextCode
      );
      if (englishChoicesMatch && englishChoicesMatch.TextValue) {
        detail.EnglishChoice = englishChoicesMatch.TextValue.split(
          detail.FieldDelimiter
        );
      }
      const questionMatch = updatedJson.find(
        (item: any) => item.TextCode === detail.QuestionTextCode
      );

      if (questionMatch) {
        detail.Question = questionMatch.TextValue;
      }
      const englishQuestionMatch = engDataJson.find(
        (item: any) => item.TextCode === detail.QuestionTextCode
      );

      if (englishQuestionMatch) {
        detail.EnglishQuestion = englishQuestionMatch.TextValue;
      }
      const enableChildMatch = updatedJson.find(
        (item: any) => item.TextCode === detail.EnableChildOnResponseCode
      );

      if (enableChildMatch) {
        detail.EnableChildOnResponse = enableChildMatch.TextValue;
      }

      const choicesMatch = updatedJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.ChoicesTextCode
      );
      if (choicesMatch && choicesMatch.TextValue) {
        detail.Choices = [choicesMatch.TextValue];
      }
      if (detail.IsNoneOfTheAboveEnabled) {
        const noneOfTheAboveTextMatch = updatedJson.find(
          (item: { TextCode: any }) =>
            item.TextCode === detail.NoneOfTheAboveTextCode
        );
        if (noneOfTheAboveTextMatch) {
          detail.NoneOfTheAboveText = noneOfTheAboveTextMatch.TextValue;
        }
      }

      let responseData = detail?.Response?.split(detail.FieldDelimiter).map(
        (item: any) => item.trim()
      );
      if (
        detail.IsNoneOfTheAboveEnabled &&
        responseData?.includes(detail?.NoneOfTheAboveText)
      ) {
        const noneOfTheAboveTextMatchEnglish = engDataJson.find(
          (item: { TextCode: any }) =>
            item.TextCode === detail.NoneOfTheAboveTextCode
        );

        if (noneOfTheAboveTextMatchEnglish) {
          detail.EnglishResponse = noneOfTheAboveTextMatchEnglish.TextValue;
        }
      }
      const sectionMatch = updatedJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.SectionName
      );
      if (sectionMatch) {
        detail.SectionName = sectionMatch.TextValue;
      }

      const subSectionMatch = updatedJson.find(
        (item: { TextCode: any }) => item.TextCode === detail.SubSectionName
      );
      if (subSectionMatch) {
        detail.SubSectionName = subSectionMatch.TextValue;
      }
      return detail;
    });
    return updatedSurveyData;
  };

  useEffect(() => {
    isAppLoading(true);
    httpGetMemberActivities()
      ?.then((res) => {
        isAppLoading(false);
        let surveyList = res.data.filter(function (item: any) {
          return item.IsRuleBasedSurvey == true;
        });
        console.log("surveyList................", surveyList);
        setSurveyList(surveyList);
        const language = LANGUAGES.find(
          (lang) => lang.id === surveyList[0].PreferredLanguage
        );
        setSurveyLanguage(language?.code || "en");
        console.log("language................", language?.code);
        var rueBasedActivitiesL = res.data
          .filter((item: any) => item.IsRuleBasedSurvey === true)
          .map((item: any) => item.TranslationGroupID);
        setrueBasedActivities(rueBasedActivitiesL);
      })
      .catch((e) => {
        isAppLoading(false);
        handleErrorNavigation(e, navigate, t);
      });
  }, []);

  useEffect(() => {
    let isComponentMounted = true;

    const fetchAllData = async () => {
      try {
        isAppLoading(true);
        const surveyRes = await httpGetMemberActivities();
        const responseList = surveyRes?.data;
        let responseData = responseList.filter(function (item: any) {
          return item.IsRuleBasedSurvey == true;
        });
        console.log("responseData................", responseData);
        setPatientActivityID(responseData.PatientActivityID);
        setLastseenPageNumberVal(responseData.LastseenPageNumber);
        let rawData = null;
        if (responseData[0].IsRuleBasedSurvey) {
          const rawDataResponse = await fetch(responseData[0].SurveyUrl);
          rawData = await rawDataResponse.json();
        }
        console.log("rawData................", rawData);
        const filteredDetails = responseData[0]?.PatientActivityDetails?.filter(
          (detail: any) => detail.QuestionType === 120000008
        );
        if (isComponentMounted) {
          setPatientActivityDetailID(
            filteredDetails[0]?.PatientActivityDetailID
          );
        }
        const languageRes = await getLanguageTranslations(
          responseData[0].TranslationGroupID,
          getLanguageId(preferredLanguageForSurvey)
        );
        console.log("languageRes................", languageRes);
        if (isComponentMounted) {
          setCachedJSON(languageRes.data || null);
          localStorage.setItem(
            "languageData",
            JSON.stringify(languageRes.data)
          );
          if (responseData) {
            const hasAnyResponseAnswered = (responseData:any) => {
              return responseData.some((activity:any) =>
                activity.PatientActivityDetails?.some(
                  (detail:any) => detail.Response !== null
                )
              );
            };
            const answeredQuestion = hasAnyResponseAnswered(responseData);
            setAnswered(answeredQuestion);
            console.log("answeredQuestion", answeredQuestion);
            console.log("answered", answered);
            console.log("surveyLanguage", surveyLanguage);
            // const langCode = getIdByCode(currentLanguage);
            const result = answeredQuestion
              ? surveyLanguage
              : appUiState.Language;
            // const langCode = getIdByCode(
            //   surveyLanguage !== "en" ? surveyLanguage : appUiState.Language
            // );
            const langCode = getIdByCode(result);
            setFinalAppLanguage(
              answeredQuestion ? surveyLanguage : appUiState.Language
            );
            console.log("langCode", langCode);
            getQuestions(responseData, langCode, languageRes.data, rawData);
          }
          isAppLoading(false);
        }
      } catch (error) {
        if (isComponentMounted) {
          console.error("Error fetching data or TranslationGroupID", error);
          isAppLoading(false);
          clearLocalStore();
          handleErrorNavigation(error, navigate, t);
        }
      }
    };

    fetchAllData();
    return () => {
      isComponentMounted = false;
    };
  }, [refreshKey]);

  const formatMultichoiceResponse = (response: any) => {
    let finalResponse =
      response !== null && response !== undefined
        ? Array.isArray(response)
          ? response
          : [response]
        : response;

    var parsedRes = Array.isArray(finalResponse)
      ? finalResponse.map((res: any) => {
          if (res && typeof res === "string") {
            return {
              label: res.trim(),
              Index: res.trim(),
              value: res.trim(),
              Selected: true,
            };
          } else {
            return {
              label: "",
              Index: "",
              value: "",
              Selected: false,
            };
          }
        })
      : [];

    return parsedRes;
  };
  // useEffect(() => {
  //   setCurrentLanguage(appUiState?.Language);
  // }, [appUiState]);
  // useEffect(() => {
  //   const preferredLang = appUiState?.Language || "en";
  //   //const preferredLang = localStorage.getItem("preferredLanguageForSurvey");
  //   //const languageToSet = preferredLang || appUiState?.Language || "en";
  //   setCurrentLanguage(preferredLang);
  // }, []);

  const getIdByCode = (code: string) => {
    const language = LANGUAGES.find((lang) => lang.code === code);
    return language?.id || null;
  };
  const proceedRuleBasedSurvey = async (obj: any) => {
    console.log("obj..............", obj);
    try {
      let data = await fetch(obj.SurveyUrl).then((res) => {
        return res.json();
      });
      console.log("data..............", data);
      let pgm = data;
      pgm["patientId"] = obj.PatientID;
      pgm["surveyID"] = obj.PatientActivityID;
      pgm["PatientActivityName"] = obj.PatientActivityName;
      pgm["IsRuleBasedSurvey"] = obj.IsRuleBasedSurvey;
      pgm["StartDate"] = obj.StartDate;
      pgm["IsPartialSaveEnabled"] = obj.IsPartialSaveEnabled;
      pgm["ResponseLanguage"] = obj.ResponseLanguage;
      pgm["LastUpdatedPageNumber"] = obj.LastUpdatedPageNumber || 0;
      const activityDetails = obj.PatientActivityDetails;
      const activityMap: any = {};
      activityDetails.forEach((detail: any) => {
        activityMap[detail.QuestionCode] = {
          PatientActivityDetailID: detail.PatientActivityDetailID,
          Response: detail.Response || null,
          Question: detail.Question,
          Choices: detail.Choices,
          ResponseCode: detail.ResponseCode,
          SectionName: detail.SectionName,
          SubSectionName: detail.SubSectionName,
          EnglishChoice: detail.EnglishChoice,
          NoneOfTheAboveText: detail.NoneOfTheAboveText,
          OtherResponse: detail.OtherResponse,
        };
      });

      if (pgm["surveyPages"] && Array.isArray(pgm["surveyPages"])) {
        pgm["surveyPages"].forEach((page: any) => {
          if (page.surveyQuestions && Array.isArray(page.surveyQuestions)) {
            page.surveyQuestions.forEach((question: any) => {
              const activityDetail = activityMap[question.questionCode];
              if (activityDetail) {
                const choicesArray =
                  activityDetail?.Choices[0]?.split("|") || [];
                const formattedChoices = question.surveyQuestionChoices.map(
                  (choice: any, index: any) => ({
                    choiceCode: choice.choiceCode,
                    choiceText: choicesArray[index] ?? "",
                    choiceTextInDefaultLanguage:
                      choice.choiceTextInDefaultLanguage,
                    scoringValue: 0,
                    isDefault: false,
                    choiceOrder: index + 1,
                  })
                );

                question.surveyQuestionChoices = formattedChoices;
                question.questionText = activityDetail.Question;
                question.EnglishChoice = activityDetail.EnglishChoice;
                question.OthersResponse = activityDetail.OtherResponse;
                if (question.questionType === 120000001) {
                  question.PatientActivityDetailID =
                    activityDetail.PatientActivityDetailID;
                  question.Response = formatMultichoiceResponse(
                    activityDetail.Response
                  );
                  question.SectionName = activityDetail.SectionName;
                  question.SubSectionName = activityDetail.SubSectionName;
                  question.NoneOfTheAboveText =
                    activityDetail.NoneOfTheAboveText;
                } else {
                  question.PatientActivityDetailID =
                    activityDetail.PatientActivityDetailID;
                  question.Response = activityDetail.Response;
                  question.ResponseCode = activityDetail.ResponseCode;
                  question.SectionName = activityDetail.SectionName;
                  question.SubSectionName = activityDetail.SubSectionName;
                }
              }
            });
          }
        });
        console.log("pgm after processing", pgm);
        return pgm;
      }
    } catch (error) {
      handleErrorNavigation(error, navigate, t);
    }
  };

  const onPartialSaveSubmitHandler = async (partialSaveData: any) => {
    const parseData = await parseToSource(partialSaveData, true);
    try {
      await partialSurveyDataRulebased(parseData);

      ReactGA.event({
        category: "Submit Button Click ",
        action: "Survey Submitted Successfully",
        label: "Survey Page",
      });
    } catch (e) {
      isAppLoading(false);
      console.log(e);
      ReactGA.event({
        category: "Submit Button Click ",
        action: "Survey Submitted Unsuccessfully",
        label: "Survey Page",
      });
      clearLocalStore();
      handleErrorNavigation(e, navigate, t);
    }
  };
  const getQuestions = (
    data: any,
    languageCode: any,
    langData: any,
    rawData: any
  ) => {
    const surveyData = data[0];
    let sortedQuestionData = surveyData.PatientActivityDetails.sort(
      (a: { QuestionNumber: number }, b: { QuestionNumber: number }) =>
        a.QuestionNumber > b.QuestionNumber ? 1 : -1
    );
    sortedQuestionData = JSON.stringify(surveyData, null, sortedQuestionData);
    let parsedSortedData = JSON.parse(sortedQuestionData);
    console.log("surveyData", surveyData);
    sortedQuestionData = JSON.parse(sortedQuestionData);
    const updatedSurveyData = updateQuestionsByLang(
      parsedSortedData,
      languageCode,
      langData,
      rawData
    );
    sortedQuestionData.PatientActivityDetails = updatedSurveyData;
    (async () => {
      let parsedSurveyData;
      if (surveyData.IsRuleBasedSurvey == true) {
        let data = await proceedRuleBasedSurvey(sortedQuestionData);
        parsedSurveyData = await parseFromSource(data);
        parsedSurveyData.pages.forEach((pg: any) => {
          pg.questionGroups.forEach((group: any) => {
            group.questions.forEach((q: any) => {
              if (q.questionType === 120000001 && q.response) {
                if (!Array.isArray(q.response.length)) {
                  let fieldDelimiter = q.fielddelimiter
                    ? q.fielddelimiter
                    : "|";
                  q.response = q.response[0]?.value
                    .split(fieldDelimiter)
                    .map((choice: string) => choice.trim());
                }
              }
            });
          });
        });
      }
      setSurveyData(parsedSurveyData);
    })();
  };

  const surveySubmitHandler = async (updatedSurveyData: any) => {
    const parseData = await parseToSource(updatedSurveyData);
    console.log(parseData);
    isAppLoading(true);
    memberPortalsubmitSurveyData(parseData)
      ?.then((res) => {
        isAppLoading(false);
        navigate("/member/memberportalthankyou", {
          replace: true,
          state: {
            rawSurveyData: rawSurveyData,
            renderHtml: renderHtml,
          },
        });

        ReactGA.event({
          category: "Submit Button Click ",
          action: "Survey Submitted Successfully",
          label: "Survey Page",
        });
      })
      .catch((e) => {
        isAppLoading(false);
        console.log(e);
        ReactGA.event({
          category: "Submit Button Click ",
          action: "Survey Submitted Unsuccessfully",
          label: "Survey Page",
        });
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
      });
  };

  const findPatientActivityDetailID = (
    questionType: any,
    questionCode: any
  ) => {
    for (const page of finalResponse?.surveyPages) {
      for (const question of page.surveyQuestions) {
        if (
          question.questionType === questionType &&
          question.questionCode === questionCode
        ) {
          return question.patientActivityDetailID;
        }
      }
    }
    return null;
  };

  const handleDataFromChild = async (fileList: any) => {
    if (fileList.uid) {
      const formData = new FormData();
      formData.append("file", fileList);
      formData.append("PatientActivityDetailID", PatientActivityDetailID);

      try {
        await submitUploadDocument(formData);
      } catch (e) {
        handleErrorNavigation(e, navigate, t);
      }
    }
  };

  const handleDelete = async (id: any) => {
    if (id) {
      isAppLoading(true);
      try {
        await deleteDocument(id);
        setRefreshKey((prev) => prev + 1);
      } catch (e: any) {
        handleErrorNavigation(e, navigate, t);
      } finally {
        isAppLoading(false);
      }
    }
  };

  const lastPageSeenNumberHandler = async (lastVisitPageData: any) => {
    let lastVisitPageDataPlus = lastVisitPageData + 1;
    logSessionDetail("SurveyPageViewed", { pageNumber: lastVisitPageDataPlus });
    if (lastseenPageNumberVal < lastVisitPageDataPlus) {
      try {
        await lastSeenPageNumberData(lastVisitPageDataPlus, patientActivityID);
      } catch (e) {
        isAppLoading(false);
        console.log(e);
        clearLocalStore();
        handleErrorNavigation(e, navigate, t);
      }
    }
  };
  console.log("surveyData____", surveyData);
  console.log("surveyLanguage______", surveyLanguage);
  console.log("appUiState.Language", appUiState.Language);
  return (
    <div data-testid="survey-page">
      <Survey
        surveyData={surveyData}
        onSubmit={surveySubmitHandler}
        onPartialSaveSubmit={onPartialSaveSubmitHandler}
        onSaveProgress={() => {}}
        lastPageSeenNumber={lastPageSeenNumberHandler}
        appLanguage={finalAppLanguage}
        // appLanguage={answered ? surveyLanguage : appUiState.Language}
        size={"md"}
        onSendData={handleDataFromChild}
        onDeleteData={handleDelete}
      />
    </div>
  );
};
export default SurveyMemberPortal;
